import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');

export const formatDateToReadable = (date: string) => {
  return moment(date).format('dddd Do MMMM YYYY');
};

export const formatShortDate = (date: string) => {
  return moment(date).format('DD/MM/YYYY');
};
